export default __webpack_public_path__ + "static/media/img1.1707b980.jpg";